export enum SearchEventTypeEnum {
  INITIAL_SEARCH,
  NAVIGATE_FACET,
  NARROW_BY_FACET,
  FILTER,
  CHANGE_PAGE,
  SORT_RESULT,
  SEARCH_FROM_MESSAGE_BOX,
  SEARCH_FROM_HEADER,
  SEARCH_FROM_DYM,
  SEARCH_FROM_URL,
  SEARCH_FROM_DYM_REFRESH
}
